import { CloseRounded } from '@mui/icons-material'
import { Button, DialogTitle, Grid, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

interface ModalHeaderProps {
  isEditing: boolean
  onClose: () => void
}

export const ModalHeader = ({ isEditing, onClose }: ModalHeaderProps) => {
  const { t } = useTranslation(['global'])

  return (
    <DialogTitle id="alert-dialog-title">
      <Grid container justifyContent="space-between">
        <Typography variant="h6">
          {isEditing ? t('edit') : t('create')} {t('live-event')}
        </Typography>
        <Button onClick={onClose} color="primary" variant="text">
          <CloseRounded />
        </Button>
      </Grid>
    </DialogTitle>
  )
}
